const translations = {
    ComingSoon: "Coming soon",
    ContactUs: "Contact us",
    FeatActivities: "E-Learning activities",
    FeatActivities_sub:
        "Create and assign and give feedback to e-learning tasks.",
    FeatChat: "Blog and chats to discuss and share",
    FeatChat_sub:
        "Share and discuss content with the whole class or discuss with smaller groups.",
    FeatCoursePlanning: "Course planning and calendar",
    FeatCoursePlanning_sub: "Fully customisable course planner.",
    FeatEvaluations: "Course evaluations",
    FeatEvaluations_sub:
        "Fully customisable evaluation forms, starting automatically",
    FeatLinksIntegration: "Links integration",
    FeatLinksIntegration_sub:
        "Enjoy beautiful integrations for videos, website previews, interactive forms and my more.",
    FeatMultimediaComments: "Pictures, videos and sounds annotations",
    FeatMultimediaComments_sub:
        "Write comments to a specific time or place. Ideal for analysis.",
    FeatMultimediaDocs: "Multimedia documents",
    FeatMultimediaDocs_sub:
        "Upload images, videos or PDFs, Isyflow will process them and display an elegant preview.",
    FeatNews: "News",
    FeatNews_sub: "Easily keep your members informed with news.",
    FeatRegistration: "Course registrations",
    FeatRegistration_sub: "Let students register directly to the courses.",
    FeatSms: "Sms sendings",
    FeatSms_sub:
        "Send automatic reminders or custom messages for unexpected events.",
    FeatTargetedCommunication: "Targeted communication",
    FeatTargetedCommunication_sub:
        "Send messages to all the teachers or all the students enrolled in a semester.",
    FeatTeacherWorkspace: "Course homepage",
    FeatTeacherWorkspace_sub:
        "Create workspaces and invite your students to start working with them.",
    Impressum: "Imprint",
    InfoPrivateRollout:
        "Isyflow has been successfully used for 5 years in Swiss and German educational institutions and universities. The platform will soon be available for individual usage.",
    Login: "Login",
    LoginOrSignup: "Login / Signup",
    Nav_Home: "Home",
    Nav_Vet: "Isyflow-VET",
    Nav_Learning: "Isyflow-Learning",
    OpenAccountTrial: "Open an account (free until 31.08.2020)",
    OrganisationFeaturesTitle: "For institutions",
    Plan_Free: "FREE",
    Plan_Guru: "GURU",
    Plan_Organisation: "Organisation",
    Plan_Pro: "PRO",
    Pricing_encoding: "{count} minutes video and sound upload per month",
    Pricing_featuresTeacher: "Teacher features",
    Pricing_featuresMiniOrg: "Homepage + workspaces hierarchy",
    Pricing_featuresOrg: "Organisation features (in option)",
    Pricing_from: "from",
    Pricing_members: "{count} members included",
    Pricing_membersAdd: "2.-/member/mo",
    Pricing_membersUnlimited: "Unlimited members",
    Pricing_perMonth: "per month",
    Pricing_perMonthAltern: "or {price}.- per year",
    Pricing_perYear: "per year",
    Pricing_storage: "{count} GB storage",
    Pricing_storageAdd: "1.-/mo per 10GB",
    Pricing_emailSupport: "Email support",
    Pricing_emailSupportPriority: "Priority email support",
    Pricing_emailAndPhoneSupportPriority: "Priority email and phone support",
    Pricing_workspace: "{count} workspace",
    Pricing_workspaces: "{count} workspaces",
    Pricing_workspacesUnlimited: "Unlimited workspaces",
    PricingTitle: "Pricing",
    PrivacyPolicy: "Privacy policy",
    PricingWarning:
        "Individuelle Pläne befinden sich in einer privaten Testphase und werden bald verfügbar sein. Bitte kontaktieren Sie uns, wenn Sie an einer Teilnahme an der Testphase interessiert sind oder informiert werden möchten, wenn diese Pläne verfügbar sind.",
    Product_Learning: "Isyflow Learning",
    Product_Learning_Desc: "The digital cockpit for teachers and institutions",
    Product_Vet: "Isyflow VET",
    Product_Vet_Desc:
        "The digital cockpit for vocational education and training",
    Products: "Products",
    TeacherFeaturesTitle: "For teachers",
    Team_Dev: "Development",
    Team_Consulting: "Consulting",
    Tutorials: "Tutorials",
    VetFeatures: "Rich functionality for every stakeholder",
    Vet_Admin: "Course management",
    Vet_AdminDesc:
        "Associations, companies and schools publish courses, receive registrations, view the list of participants, trigger invoices, handle the face-to-face or online course in Isyflow and automatically send participation confirmations. You produce multimedia and interactive e-learning units in Isyflow and make them available for free or for a fee.",
    Vet_LearnPlan: "Educational plans and digital forms",
    Vet_LearnPlanDesc:
        "Associations and Oda's make their education plans and all digital forms for learning documentation, evaluations and semester reports available in one app in Isyflow. They can send news and regular and automated reminders, organize final exams and manage their evaluations.",
    Vet_SiteCoop: "Learning site cooperation",
    Vet_SiteCoopDesc:
        "Schools and training centers can use practical examples in class which the learners have approved after consultation. They learn which learners have done or not done similar things in their companies and can differentiate these groups in courses and thus supplement the company training in a targeted manner. Schools and Üks can visibly enter the learning objectives covered and tested for the companies.",
    Vet_Situated: "Situated training material",
    Vet_SituatedDesc:
        "Schools and inter-company courses assign training materials to situations. Vocational trainers link these exercises and learning materials to their learners as needed and receive a message when they have been worked through.",
    Vet_Skills: "Competences and situations",
    Vet_SkillsDesc:
        "The vocational trainers receive a message when feedback is needed on an evaluation or learning documentation. The documented work situations of the learners are linked to the competencies or situations of the educational plans. This creates a clear picture of progress. In addition, personal development (work organization, flexibility, etc.) is recorded and can be discussed over time.",
    VetFeat_Oda: "Association, OdA",
    VetFeat_Oda_0: "Records educational plans",
    VetFeat_Oda_1:
        "Provides forms for evaluations, learning documentation, semester reports.",
    VetFeat_Oda_2:
        "Organizes trainings and courses: announcement, registration, list of participants, documents etc.",
    VetFeat_Oda_3:
        "Creates e-learning units: multimedia and interactive, with embedded simulations",
    VetFeat_Oda_4: "Provides training documents ready for printing",
    VetFeat_Oda_5: "Organizes exams and manages assessments",
    VetFeat_Comp: "Company and supervisors",
    VetFeat_Comp_0:
        "Automate administrative processes and use the platform for their own documents",
    VetFeat_Comp_1:
        "Receive a cockpit with training level and personality development all learners",
    VetFeat_Comp_2:
        "Fill out learning documentation, evaluation, semester report online",
    VetFeat_Comp_3: "Receive notification when feedback is required",
    VetFeat_Comp_4:
        "File their own documents such as instructions, processes, product information",
    VetFeat_Comp_5: "Send news to all learners or trainers",
    VetFeat_School: "School and inter-company courses",
    VetFeat_School_0:
        "Get a connection with companies or use Isyflow as a training platform",
    VetFeat_School_1: "Record covered learning objectives to inform practice",
    VetFeat_School_2: "Provide the practice documents and exercises",
    VetFeat_School_3: "Receive examples from practice",
    VetFeat_Stud: "Learners",
    VetFeat_Stud_0:
        "Document via smartphone, have access to personalized exercises; receive reminders of tasks and deadlines",
    VetFeat_Stud_1:
        "Process digital reports and evaluation forms, receive feedback",
    VetFeat_Stud_2: "Use protected chat with trainers",
    VetFeat_Stud_3: "See training progress and personality development",
    VetFeat_Stud_4:
        "Provide practical examples for training centers and schools",
    VetFeat_Stud_5: "Receive a competence profile for job applications",
    VetFeat_Stud_6:
        "Record further training and receive further training offers",
    VetFeat_Admin: "Administration (*)",
    VetFeat_Admin_0: "Sends newsletters to learners, schools, companies",
    VetFeat_Admin_1: "Records educational plans",
    VetFeat_Admin_2:
        "Creates work/learning spaces and chats for project groups and courses",
    VetFeat_Admin_3: "Pulls together information in functional cockpits",
    VetFeat_Admin_4:
        "Creates forms for learning documentation, semester reports, evaluations and for recording personal development",
    VetFeat_Admin_5:
        "Stores training documents and assigns them to training objectives and situations",
    VetFeat_Admin_6: "Creates e-learning units (*)",
    VetFeat_Admin_7:
        "Creates courses incl. registration, implementation, invoicing (*)",
    VetFeat_Admin_8:
        "Prepares single sign on and integration with existing school platforms such as Microsoft Teams or Moodle (*)",
    VetPrice_1: "40.- per learner for the duration of their training",
    VetPrice_1_1:
        "from 250 to 2000 new apprenticeship contracts per year, thereafter graduated prices",
    VetPrice_2: "28.- for use after the training",
    VetPrice_2_1:
        "As lifelong learning documentation, proof of experience and continuing education",
    VetPrice_3: "10.- additional for (*) functions.",
    WelcomeTitle: "The learning platform for the digital age.",
    WelcomeSubtitle:
        "Isyflow is an online platform that offers easy to use yet effective communication, collaboration and management tools to innovative teachers and training institutions."
};

export default translations;
